import { useNavigate } from 'react-router-dom';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Eye, Link } from 'lucide-react';
import { useTimezoneUtils } from '@/hooks/useTimezoneUtils';

interface CustomerLeadsTableProps {
  leads: any[];
}

export function CustomerLeadsTable({ leads }: CustomerLeadsTableProps) {
  const navigate = useNavigate();
  const { formatDate } = useTimezoneUtils();

  const getStatusColor = (status: string) => {
    const colors: Record<string, string> = {
      new: 'bg-info',
      contacted: 'bg-warning',
      qualified: 'bg-primary',
      converted: 'bg-success',
      lost: 'bg-destructive',
    };
    return colors[status] || 'bg-muted-foreground';
  };

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Lead Number</TableHead>
            <TableHead>Service Type</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Created</TableHead>
            <TableHead>Quoted Price</TableHead>
            <TableHead>CSR</TableHead>
            <TableHead>Tech</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {leads.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} className="text-center text-muted-foreground">
                No leads found
              </TableCell>
            </TableRow>
          ) : (
            leads.map((lead) => (
              <TableRow
                key={lead.id}
                className="cursor-pointer hover:bg-muted/50"
                onClick={() => navigate(`/leads/${lead.id}`)}
              >
                <TableCell className="font-medium">{lead.lead_number}</TableCell>
                <TableCell>{lead.service_types?.name || 'N/A'}</TableCell>
                <TableCell>
                  <Badge className={getStatusColor(lead.status)}>
                    {lead.status}
                  </Badge>
                </TableCell>
                <TableCell>{formatDate(lead.created_at, 'MMM dd, yyyy')}</TableCell>
                <TableCell>${lead.quoted_price?.toFixed(2) || '0.00'}</TableCell>
                <TableCell>{lead.csr_profile?.full_name || 'N/A'}</TableCell>
                <TableCell>{lead.tech_profile?.name || 'N/A'}</TableCell>
                <TableCell className="text-right" onClick={(e) => e.stopPropagation()}>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => navigate(`/leads/${lead.id}`)}
                    title="View Lead"
                  >
                    <Eye className="h-4 w-4" />
                  </Button>
                  {lead.job_id && (
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => navigate(`/jobs/${lead.job_id}`)}
                      title="View Linked Job"
                      className="text-info hover:text-info hover:bg-info/10"
                    >
                      <Link className="h-4 w-4" />
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
